// Single import point for packages/taste (browser-safe entry), imported from source
// like core and match. Used for the Follow-taste Nostr reader (readCreatorPicks) and
// the Creator studio's "Publish my picks".
export * from "../../../../../packages/taste/src/index.ts";
